import { gql } from '@apollo/client';

export const GET_ALL_FINAL_EXAMS_FOR_USER = gql`
  query GetAllFinalExamsForUser {
    getAllFinalExamsForUser {
      id
      userId
      tags
      userQuestions {
        questionId
        question {
          id
          prompt
          tag
          options {
            desc
            isAnswer
          }
        }
        selectedOption {
          desc
          isAnswer
        }
      }
      isCompleted
      completedAt
      updatedAt
      createdAt
    }
  }
`;
